import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterUser'
})
export class FilterUserPipe implements PipeTransform {

  transform(users: any[], searchText: string): any[] {
    if (!users) return [];
    if (!searchText) return users;
    console.log('searchText: ',searchText)
    if(searchText){
      searchText = searchText.toLowerCase();
    }
    
    return users.filter(user => {
      console.log('user z pipe ',user)
      const matchesname = user.name.toLowerCase().includes(searchText);
      const matchesEmail = user.email.toLowerCase().includes(searchText);
    //  const matchesRole = user.roles.some(role => role.name.toLowerCase().includes(searchText));
      return matchesname || matchesEmail;
    });
  }

}
